import './Register/step2';
import { getActiveHealthPlan } from "./Register/step2";
import { setDisplay, validateForm } from "./helpers";
var payload = {}
var providerOptions = []

const toggleDropdown = () => {
  const dropdown = document.getElementById('optionsDropdown');
  dropdown.style.display = dropdown.style.display === 'block' ? 'none' : 'block';
}

const closeDropdown = () => {
  const dropdown = document.getElementById('optionsDropdown');
  dropdown.style.display = 'none';
}

const changeSelect = (firstSel, secondSel, valuesObject) => {
  firstSel.onchange = function () {
    secondSel.length = 1;
    let secondSelectOption = valuesObject[firstSel.value];
    if (this.selectedIndex < 1) {
      secondSelectOption = providerOptions
    };

    secondSelectOption.forEach((option) => {
      secondSel.options[secondSel.options.length] = new Option(option.name, option.id, false, secondSelectOption.length < 2);
    })
  }
}


document.addEventListener('DOMContentLoaded', function () {
  const elem = document.getElementById('env-vars')
  const envVarsDiv = JSON.parse(elem.attributes.data.value);

  const pacUserTypeInternalId = envVarsDiv["pac_user_type_internal_id"];
  const dischargePlannerInternalId = envVarsDiv["discharge_planner_internal_id"];
  const physicianInternalId = envVarsDiv["physician_user_type_internal_id"];
  const physicianProviderType = envVarsDiv["physician_provider_type"];
  const ambetterHealthPlanId = envVarsDiv["ambetter_health_plan_id"];

  const userTypeDropDown = document.getElementById('user_user_type');

  const healthPlanList = document.getElementById('health_plan_options');
  const originalHealthPlanItems = Array.from(healthPlanList.children);
  
  const selectedOptionsContainer = document.getElementById('selectedOptions');

  userTypeDropDown.addEventListener('change', function() {
    selectedOptionsContainer.innerHTML = "";
    const selectedUTValue = userTypeDropDown.value;
    if (selectedUTValue == physicianInternalId) {
      const healthPlanListItems = document.querySelectorAll('#health_plan_options li');
      healthPlanListItems.forEach(function(li){
        const inputValue = li.querySelector('input').value;
        li.querySelector('input').checked = false;
        if (inputValue !== ambetterHealthPlanId && inputValue !== 'Not Listed') {
          li.remove();
        }
      });
    } else {
      resetList();
    }
    updateSelectedOptions();
  });

  function resetList() {
    healthPlanList.innerHTML = '';

    originalHealthPlanItems.forEach((item) => {
      healthPlanList.appendChild(item.cloneNode(true));
    });

    const planCheckboxes = document.querySelectorAll(`#optionsDropdown input[type="checkbox"]`);

    planCheckboxes.forEach((checkbox) => {
      checkbox.checked = false;
      checkbox.addEventListener('change', () => updateSelectedOptions());
    });
  }

  var span = document.getElementsByClassName('close')[0];

  const selectElement = document.getElementById('user_provider_type');
  span.onclick = () => {
    setDisplay('.register-modal', 'none');
    setDisplay('.based-our-records', 'none');
    setDisplay('.user-created', 'none');
  };
  
  providerOptions = Array.from(selectElement.options)
    .filter(option => option.value !== '')
    .map(option => ({ id: option.value, name: option.text }))

  const valuesObject = {
    [pacUserTypeInternalId]: providerOptions.filter(item => item.name.includes("Post-Acute") || item.name.includes('Other')),
    [dischargePlannerInternalId]: providerOptions.filter(item => item.name.includes("Discharge Planner") || item.name.includes('Other')),
    [physicianInternalId]: providerOptions.filter(item => item.name.includes("Ordering Physician") || item.name.includes('Other'))
  };

  const userSel = document.getElementById("user_user_type");
  const providerSel = document.getElementById("user_provider_type");

  changeSelect(userSel, providerSel, valuesObject)

  providerSel.onchange = function () {
    if (this.value === "PPT5") {
      setDisplay('.register-modal', 'flex');
      setDisplay('.pardon-our-dust', 'block');
      this.value = "";
    }
  }

  const customDropdown = document.getElementById('customDropdown');
  const checkboxes = document.querySelectorAll('#optionsDropdown input[type="checkbox"]');
  const allFields = document.querySelectorAll('[required="required"]');
  const requiredFields = Array.from(allFields).filter(field => field.offsetParent !== null || field.id === 'user_health_plan'
  );
  const verifyBtn = document.getElementById('verify-btn');

  let notVisibleCount = 0;
  let notVisibleList = []

  document.addEventListener('click', (event) => {
    const target = event.target;
    target.closest('.custom-dropdown') === customDropdown ?
      toggleDropdown() :
      closeDropdown();
  });

  checkboxes.forEach((checkbox) => {
    checkbox.checked = false;
    checkbox.addEventListener('change', () => updateSelectedOptions());
  });
  updateSelectedOptions();

  verifyBtn.disabled = true;
  verifyBtn.classList.add("disabled")
  requiredFields.forEach((field) => {
    field.addEventListener('change', () => {
      const hasError = validateForm(requiredFields, true);
      if (hasError.isValid) {
        verifyBtn.disabled = false;
        verifyBtn.classList.remove("disabled");
        verifyBtn.classList.remove("button--secondary");
        verifyBtn.classList.add("button--purple");
      }
      else {
        verifyBtn.disabled = true;
        verifyBtn.classList.add("disabled");
        verifyBtn.classList.add("button--secondary");
        verifyBtn.classList.remove("button--purple");
      }
    });
  });

  verifyBtn.addEventListener('click', () => {
    const providerPortalType = document.getElementById('user_provider_type').value;
    const healthPlans = document.getElementById('user_health_plan').value;
    const isValidated = validateForm(requiredFields);

    if (providerPortalType === physicianProviderType && !healthPlans.includes(ambetterHealthPlanId)) {
      setDisplay('.register-modal', 'flex');
      setDisplay('.pardon-our-dust', 'block');
      return;
    }

    if (isValidated.isValid) {
      setDisplay('.alert-container', 'none');
      setDisplay('#loader', 'none');
      document.querySelector("#step2").classList.add("active");

      document.querySelector("#step1-view").classList.remove("active");
      document.querySelector("#step2-view").classList.add("active");

      document.querySelector("#step-count").innerText = "2"
      const fields = document.querySelectorAll('[required="required"]');

      payload = {
        "user": {
          "user_type": fields[3].value,
          "provider_type": fields[4].value,
          "first_name": fields[0].value,
          "last_name": fields[1].value,
          "email": fields[2].value
        },
        "health_plans": []
      }

      const healthPlanValues = document.getElementById('user_health_plan').value.split(",");

      healthPlanValues.forEach((healthPlan) => {
        payload["health_plans"].push({
          "internal_id": healthPlan
        })
      });
      payload['health_plans'][0].active = true;

      getActiveHealthPlan(payload);
    } else {
      setDisplay('.alert-container', 'block');
      var alertClose = document.getElementById('js-alert-close');
      alertClose.onclick = () => setDisplay('.alert-container', 'none');
      setTimeout(() => { setDisplay('.alert-container', 'none') }, 5000)
    }
  });
  function updateSelectedOptions() {
    const CHAR_LIMIT = 35
    const selectedOptions = Array.from(document.querySelectorAll('#optionsDropdown input[type="checkbox"]'))
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);

    if (selectedOptions.includes('Not Listed')) {
      setDisplay('.register-modal', 'flex');
      setDisplay('.pardon-our-dust', 'block');
      checkboxes[checkboxes.length - 1].checked = false;
      return;
    }

    selectedOptionsContainer.innerHTML = "";
    let addedOptions = [];

    notVisibleCount = 0;
    notVisibleList = [];

    selectedOptions.forEach((option, index) => {
      const healthPlanText = getTextFromOption(option);
      addedOptions.push(healthPlanText)
      if (index === 0 || addedOptions.join(',').length <= CHAR_LIMIT) {
        const tag = `<span class="selected-plan">${healthPlanText}<span class="close-icon">x</span></span>`
        selectedOptionsContainer.insertAdjacentHTML("beforeend", tag);
      } else {
        notVisibleCount++;
        notVisibleList.push(healthPlanText);
      }
    });

    let overflowCount = document.getElementById('overflowCount');
    if (!overflowCount) {
      overflowCount = createOverflowCountElement();
      selectedOptionsContainer.appendChild(overflowCount);
    }

    if (notVisibleCount > 0) {
      overflowCount.textContent = '+' + notVisibleCount;
      overflowCount.setAttribute('data-tooltip', notVisibleList.join(', '));
      overflowCount.style.display = 'inline';
    } else if (overflowCount) {
      overflowCount.style.display = 'none';
      selectedOptionsContainer.removeChild(overflowCount);
      overflowCount = null;
    }
    const healthPlanSelect = document.getElementById('user_health_plan');
    healthPlanSelect.value = selectedOptions.join(',');
    healthPlanSelect.dispatchEvent(new Event('change'));

    const closeIcons = selectedOptionsContainer.querySelectorAll('.close-icon');
    closeIcons.forEach((closeIcon, index) => {
      closeIcon.addEventListener('click', () => removeTagAndCheckbox(index));
    });
  }

  function createOverflowCountElement() {
    var overflowCountElement = document.createElement('div');
    overflowCountElement.className = 'overflow-count';
    return overflowCountElement;
  }

  function removeTagAndCheckbox(index) {
    const selectedOptions = Array.from(document.querySelectorAll('#optionsDropdown input[type="checkbox"]'))
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) =>
        checkbox.labels.length > 0 ? checkbox.labels[0].textContent.trim() : checkbox.textContent.trim()
      );
    const removedOption = selectedOptions[index];
    selectedOptions.splice(index, 1);

    const correspondingCheckbox = Array.from(document.querySelectorAll('#optionsDropdown input[type="checkbox"]')).find(
      (checkbox) =>
        checkbox.labels.length > 0
          ? checkbox.labels[0].textContent.trim() === removedOption
          : checkbox.textContent.trim() === removedOption
    );

    if (correspondingCheckbox) {
      correspondingCheckbox.checked = false;
    }

    updateSelectedOptions();
  }
});

const getTextFromOption = (option) => {
  const checkbox = document.querySelector(`input[type="checkbox"][value="${option}"]`);
  return checkbox.nextElementSibling.querySelector('span').innerText;

}

export const getPayload = () => payload;